import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiTabs from '@mui/material/Tabs';

import { black80, veryLightGrey, steelGrey } from '~/styles';

export const Tabs = styled(MuiTabs)`
  display: flex;
  align-items: center;
  .MuiTabs-indicator {
    display: none;
  }
` as React.FC<PropsWithChildren<React.ComponentProps<typeof MuiTabs>>>;

export const TabTitle = styled.div`
  font-size: 22px;
  color: ${black80};
  text-transform: none;
  font-weight: 500;
  margin-top: 15px;
`;

export const TeacherBio = styled.div`
  font-size: 1rem;
  line-height: 1.75;
  color: ${steelGrey};
  text-transform: none;
  font-weight: 400;
  letter-spacing: 0.5px;
  font-family: Montserrat;
  text-align: left;
`;

export const AccordionDetails = styled(MuiAccordionDetails)`
  background-color: none;
`;

export const AccordionSummary = styled(MuiAccordionSummary)`
  background-color: ${veryLightGrey};
  .MuiPaper-elevation1 {
    box-shadow: none;
  }
  .MuiPaper-root {
    box-shadow: none;
  }
  .MuiAccordionSummary-root {
    transition: none;
  }
`;
